class StickyProduct {
  constructor () {
    this.screen = null;
    this.pointMobile = 989;
    this.init();
  }

  init () {
    this.screen = window.innerWidth >= this.pointMobile ? "desktop" : "mobile";
    this.initsticky();
  }

  initsticky () {
    const checkContainer = document.querySelector(".js-btn-sticky-container");
    const elemArr = document.querySelectorAll(".js-btn-sticky");
    if (elemArr.length > 0) {
      elemArr.forEach(elem => {
        document.addEventListener("scroll", () => {
          if (this.screen == "mobile") {
            let addToCartBtnOffset = checkContainer.offsetTop,
              windowScrollTop = window.scrollY;
            if (windowScrollTop > addToCartBtnOffset)
              elem.classList.add("product__button--sticky");
            else
              elem.classList.remove("product__button--sticky");
          } else {
            if (elem)
              elem.classList.remove("product__button--sticky");
          }
        });
      });
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const stickyProduct = new StickyProduct();
  
  async function checkTryNow() {
   function waitFor(predicate) {
    return new Promise((resolve, reject) => {
      const check = () => {
        // console.log('checking', predicate())
        if (!predicate()) return
        clearInterval(interval)
        resolve()
  
        setTimeout(() => {
          stickyProduct.init();
        }, 150)
      }
      const interval = setInterval(check, 100)
      check()
    })
  }
     
    await waitFor(() => window.trynow);
  }

  checkTryNow();
});
